import { connect } from 'react-redux'
import { selectCurrentAgent } from 'selectors/agents/base'
import {
  selectAccountCanSeePinnedSearches,
  selectCurrentSortOrder,
} from 'selectors/app'
import {
  selectPrefersClassicView,
  selectPrefersUnifiedInbox,
} from 'ducks/currentUser/selectors'
import { selectCurrentTicketSearchMailboxId } from 'selectors/search'
import { selectShowOnboardingWorkflow } from 'subapps/onboarding/selectors'
import { doOpenSearchPage } from 'actions/pages'
import { doStartSearchTimer } from 'actions/metrics'

import {
  selectLeftNavMailboxes,
  selectLeftNavFolders,
  selectPinnedSearchesListItems,
  selectLeftNavShowBookDemoCard,
  selectLeftNavShowTeammatesCard,
} from 'selectors/left_nav'

import View from './view'

const select = state => {
  const currentMailboxId = selectCurrentTicketSearchMailboxId(state)
  const mailboxes = selectLeftNavMailboxes(state)
  const mailboxId = currentMailboxId || (mailboxes && mailboxes[0]?.id)

  return {
    allFolders: selectLeftNavFolders(state),
    canSeePinnedSearches: selectAccountCanSeePinnedSearches(state),
    currentAgent: selectCurrentAgent(state),
    mailboxId,
    mailboxes,
    prefersUnifiedInbox: selectPrefersUnifiedInbox(state),
    sortOrder: selectCurrentSortOrder(state),
    starredSearches: selectPinnedSearchesListItems(state),
    is3ColumnView: selectPrefersClassicView(state),
    showBookDemoCard: selectLeftNavShowBookDemoCard(state),
    showTeammatesCard: selectLeftNavShowTeammatesCard(state, mailboxId),
    showOnboardingWorkflow: selectShowOnboardingWorkflow(state),
  }
}

const perform = {
  doOpenSearchPage,
  doStartSearchTimer,
}

export default connect(select, perform)(View)
